import _ from "lodash";
import {
  DxCantHaveValue,
  DxCantHavePrimaryValue,
  DxCantHaveSecondaryValue,
} from "containers/PolicyTranslation/Constants/PolicyTranslationConstants";
import { sanitizeCC } from "./shared";

export const convertDxLimitForCantHave = (clob) => {
  if (
    clob &&
    clob.PolicyBusinessRulesList &&
    clob.PolicyBusinessRulesList.length
  ) {
    const clonedClob = _.cloneDeep(clob);
    const clonedRuleList = _.cloneDeep(clob.PolicyBusinessRulesList);
    let count = 0;
    clonedClob.PolicyBusinessRulesList.forEach((rule, i) => {
      if (rule.RuleFacts?.DXLimitation === DxCantHaveValue.value) {
        //Can't Have
        const primaryRule = {
          ...rule,
          RuleFacts: {
            ...rule.RuleFacts,
            DXLimitation: DxCantHavePrimaryValue.value, //DxCantHavePrimary
            DxDisplayValueKey: DxCantHavePrimaryValue.label,
          },
        };
        const secondaryRule = {
          ...rule,
          RuleFacts: {
            ...rule.RuleFacts,
            DXLimitation: DxCantHaveSecondaryValue.value, //DxCantHaveSecondary
            DxDisplayValueKey: DxCantHaveSecondaryValue.label,
          },
        };
        clonedRuleList.splice(i + count, 1, primaryRule, secondaryRule);
        count++;
      }
    });
    clonedClob.PolicyBusinessRulesList = clonedRuleList;
    return clonedClob;
  }
  return clob;
};

export const convertDxLimitToCantHave = (clob) => {
  if (
    clob &&
    clob.PolicyBusinessRulesList &&
    clob.PolicyBusinessRulesList.length
  ) {
    const clonedClob = _.cloneDeep(clob);
    const clonedRuleList = _.cloneDeep(clob.PolicyBusinessRulesList);
    let count = 0;
    clonedClob.PolicyBusinessRulesList.forEach((rule, i) => {
      if (
        i < clonedClob.PolicyBusinessRulesList.length - 1 &&
        rule.RuleFacts?.DXLimitation === DxCantHavePrimaryValue.value &&
        clonedClob.PolicyBusinessRulesList[i + 1].RuleFacts?.DXLimitation ===
          DxCantHaveSecondaryValue.value
      ) {
        const cantHaveRule = {
          ...rule,
          RuleFacts: {
            ...rule.RuleFacts,
            DXLimitation: DxCantHaveValue.value,
            DxDisplayValueKey: DxCantHaveValue.label,
          },
        };
        clonedRuleList.splice(i + count, 2, cantHaveRule);
        count--;
      }
    });
    clonedClob.PolicyBusinessRulesList = clonedRuleList;
    return clonedClob;
  }
  return clob;
};

export const consolidateRules = (clob) => {
  if (
    clob &&
    clob.PolicyBusinessRulesList &&
    clob.PolicyBusinessRulesList.length
  ) {
    // Grouping data by a unique combination of ProcedureCode, CodingClassification, and DiagnosisListExpanded
    const clonedClob = _.cloneDeep(clob);
    const grouped = {};
    clonedClob.PolicyBusinessRulesList.forEach((item) => {
      const procedureCode = item.RuleFacts?.ProcedureCode ?? "";

      if (!procedureCode) return;

      const codingClassification = item.RuleFacts?.CodingClassification ?? "";
      const diagnosisListExpanded =
        item.RuleFacts?.DiagnosisListExpanded?.split(",")?.sort()?.join(",") ??
        "";
      const editRule = item.RuleHeader?.EditRule ?? "";
      const ruleEndDate = item.RuleFacts?.RuleEndDate ?? "";

      const key = `${procedureCode}|${codingClassification}|${diagnosisListExpanded}|${editRule}|${ruleEndDate}`;

      if (!grouped[key]) {
        // Initialize grouped entry
        grouped[key] = {
          ...item,
          tempIdList: [item.tempId],
        };
      } else {
        // Consolidate items
        grouped[key].RuleFacts.CoverageCriteriaList = sanitizeCC(
          grouped[key].RuleFacts.CoverageCriteriaList +
            "," +
            item.RuleFacts.CoverageCriteriaList
        );

        grouped[key].tempIdList.push(item.tempId);
      }
    });

    // Convert the grouped object back to an array
    clonedClob.PolicyBusinessRulesList = Object.values(grouped);
    return clonedClob;
  }
  return clob;
};

export const deConsolidateRules = (oldRulesList, newRulesList) => {
  const finalRulesList = [];

  newRulesList.forEach((rule) => {
    if (!rule.tempIdList || rule.tempIdList.length === 1) {
      finalRulesList.push(rule);
    } else {
      rule.tempIdList.forEach((id) => {
        const oldRule = findRuleFromList(oldRulesList, id);
        if (rule.RuleHeader.EditRule)
          oldRule.RuleHeader.EditRule = rule.RuleHeader.EditRule;

        let oldEditRule = oldRule.RuleHeader?.EditRule || "";

        if (["NEW", "VARIANCE"].includes(oldEditRule)) {
          oldRule.RuleFacts.DiagnosisListExpanded =
            rule.RuleFacts.DiagnosisListExpanded;
          oldRule.RuleFacts.CodingClassification =
            rule.RuleFacts.CodingClassification;
          oldRule.RuleFacts.CoverageCriteriaList =
            rule.RuleFacts.CoverageCriteriaList;
          delete oldRule.ruleKey;
        }

        if (rule.RuleHeader.RuleVersion)
          oldRule.RuleHeader.RuleVersion = rule.RuleHeader.RuleVersion;

        finalRulesList.push(oldRule);
      });
    }
  });
  return finalRulesList;
};

export const findRuleFromList = (list, tempId) => {
  return _.cloneDeep(list.find((rule) => rule.tempId === tempId));
};
